import { ChefHat } from "lucide-react";

const items = [
  "Flagship Facility · DIP Phase 2",
  "Coverage · Dubai South",
  "Al Furjan",
  "Green Community · DIP",
  "Jebel Ali Village",
  "Jumeirah Beach Residence",
  "Just Bring Your Pots & Pans",
  "Talabat · Deliveroo · Noon",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-gold/15 bg-forest-deep py-5" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif text-lg italic tracking-wide text-gold/90 md:text-xl">{item}</span>
            <ChefHat size={16} className="text-gold/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
